import React, { useState, useEffect } from "react";
import { FaSignInAlt } from "react-icons/fa";

import { Col } from "react-bootstrap";

import { useHistory } from "react-router-dom";
import Notification, { Error } from "../../../Modules/Notifications";

import Input from "../../../Components/Input";
import Form from "../../../Components/Form";
import Button from "../../../Components/Button";
import Img from "../../../Components/Img";
import ButtonsGrid from "../../../Components/ButtonsGrid";

import api from "../../../service/api";

import useLoading from "../../../hooks/useLoading";

import Logo from "../../../Assets/Images/logo-ecobrite.png";

import "./styles.css";

const LoginArea = () => {
    const history = useHistory();
    const [identifier, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const { loading } = useLoading();

    useEffect(() => {
        localStorage.clear();
    }, []);

    const handleLogin = async (event) => {
        const idLoading = loading();

        try {
            event.preventDefault();

            if (!identifier || !password) {
                loading(idLoading);

                Notification(
                    "warning",
                    "Nome de usuário e senha são obrigatórios"
                );
                return;
            }

            const response = await api.post(
                "/auth/local",
                { identifier, password },
                { headers: { Authorization: "" } }
            );

            localStorage.setItem("token", `Bearer ${response.data.jwt}`);
            api.defaults.headers.Authorization = `Bearer ${response.data.jwt}`;

            history.push("/ctop/home");

            loading(idLoading);
        } catch (error) {
            Error(error);

            loading(idLoading);
        }
    };

    return (
        <div className="main-login row">
            <div className="logo-login">
                <Img
                    src={Logo}
                    max-height="400px"
                    className="border-0 shadow-none"
                />
            </div>
            <div className="col">
                <div className="container-login">
                    <Col>
                        <h2>Área Admin</h2>
                    </Col>
                    <Form onSubmit={handleLogin}>
                        <Input
                            type="text"
                            label="Entrada"
                            placeholder="E-mail ou nome de usuário"
                            onChange={(event) =>
                                setUsername(event.target.value)
                            }
                        />
                        <Input
                            type="password"
                            label="Senha"
                            placeholder="Entre com a senha"
                            onChange={(event) =>
                                setPassword(event.target.value)
                            }
                        />
                        <ButtonsGrid>
                            <Button variant="success" type="submit">
                                <FaSignInAlt />
                                Entrar
                            </Button>
                        </ButtonsGrid>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default LoginArea;
